import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from 'react-bootstrap';

const SearchModal = ({ show, handleClose }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    console.log('Search query:', searchQuery);
    // Perform search logic here
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Search</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSearchSubmit}>
          <Form.Group controlId="searchInput">
            <Form.Label>Search</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter search query"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Search
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SearchModal;